import * as React from 'react';

import {CardContentWithHeader} from '../card/card-content-with-header';
import {Checkbox} from '../checkbox/checkbox';

import styles from './settings-group.module.css';

type Props = {
    header: string;
    subheader: string;
    allGroupSettings: {
        id: string;
        name: string;
    }[];
    selectedGroupSettings: any[];
    onSettingChange: (id: string, checked: boolean) => void;
    disabled?: boolean;
};

export function SettingsGroup(props: Props) {
    return (
        <CardContentWithHeader
            fitContent={false}
            title={props.header}
            subtitle={props.subheader}
            content={
                <div className={styles['settings-group-list']}>
                    {props.allGroupSettings.map(({id, name}) => (
                        <Checkbox
                            key={id}
                            // @ts-expect-error
                            value={id}
                            label={name}
                            checked={props.selectedGroupSettings.includes(id)}
                            onChange={(checked) => {
                                props.onSettingChange(id, checked);
                            }}
                            disabled={props.disabled}
                        />
                    ))}
                </div>
            }
        />
    );
}
